<template>
    <div class="page-bg login">
    
        <v-container fill-height justify-center>
    
            <div class="login-block">
    
                <div class="Client-logo">
    
                    <img :src="logo" class="Client-logo-img" />
    
                </div>
    
                <v-form class="login-frm">
    
                    <v-row>
    
                        <v-col cols="12" sm="12" class="pad-zero">
    
                            <v-text-field v-model="emailid" label="Email ID/ User ID" dense outlined></v-text-field>
    
                        </v-col>
    
                        <v-col cols="12" sm="12" class="pad-zero">
    
                            <div class="radio-inline-cls">
    
                                <span class="send-verification">
    
                            Send verification code by
    
                        </span>
    
                                <v-radio-group v-model="mode" row>
    
                                    <v-radio label="Email" color="red" :value="modes.EMAIL"></v-radio>
    
                                    <v-radio label="Mobile" color="red" :value="modes.MOBILE"></v-radio>
    
                                </v-radio-group>
    
                            </div>
    
                        </v-col>
    
    
    
                        <v-col cols="12" sm="12" class="pad-zero">
    
                            <div class="signup-primary top-0">
    
                                <div class="user-new-signup"> </div>
    
                                <div class="sign-up-btn">
    
                                    <v-btn :loading="loading" @click="onGoClick" class="right-btn cust-btn" color="primary">Go</v-btn>
    
                                </div>
    
                            </div>
    
                        </v-col>
    
                    </v-row>
    
                </v-form>
                <div v-if="isDefaultInstitute && myInstitute && !myInstitute.is_white_labeled" class="power-logo">
    
                    <img src="@/assets/img/logo-footer.png" class="master-logo" />
    
                </div>
    
            </div>
    
        </v-container>
    
        <OTPModal :status="status" :onClose="onClose" :handleOnComplete="onCompleteOTP" :otpErrMessage="otpErrMessage" />
    
    </div>
</template>
<script>
import { mapActions, mapState } from "vuex";
export default {
    name: 'sendotp',
    data() {
        return {
            loading: false,
            logo: this.getInstituteLogo(),
            status: false,
            otpErrMessage:null,
            emailid:'',
            mode:'',
        }
    },
    methods: {
        ...mapActions({
            forgotPassword: "userStore/forgotPassword",
            verifyOTP:"userStore/verifyOTP"
        }),
        onGoClick() {
          
            if (!this.emailid) {
                this.$toasted.error("Enter Valid email Id or user Id ", { icon: 'info' });
            } else if (!this.mode) {
                this.$toasted.error("Please select a mode to reset your password – Email / Mobile", { icon: 'info' });
            } else {
                this.loading = true;
                this.forgotPassword({ email: this.emailid, mode: this.mode }).then(response => {
                        this.loading = false;
                       
                        if(this.mode===this.modes.MOBILE)
                        {
                          this.status=true;                         
                        }
                        else{
                          this.$toasted.success(`Success\n${response.msg}`, { icon: 'check_circle' });
                          this.$router.push({ name: "login" }).catch(() => {});
                        }
                    })
                    .catch(err => {
                        this.loading = false;
                    });
            }

        },
        onClose() {
            this.status = false;
            this.otpErrMessage=null;
        },
        onCompleteOTP(otp)
        {
          
          this.verifyOTP({ otp: otp, userId: this.emailid })
          .then(response => {
            this.status = false;
            this.otpErrMessage=null;
             this.$route.params.token=otp;
             this.$router.push({ name: "new-password" });
            
                        
          })
          .catch(err => {
            if (err && err.errors && err.errors.length) {
                            this.otpErrMessage = err.errors[0].message;
              }
           });
        }
    },
    computed: {
		...mapState('userStore', ['isDefaultInstitute','myInstitute']),
	}
}
</script>
